import cn from "classnames";
import { Transition } from "components/shared/column";
import Datetime from "components/shared/datetime";
import { paths } from "helpers/paths";
import React, { useEffect, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { requestStatistics } from "sources/admin";
import { RequestsCount, RequestsDuration, RequestsRate, RequestsSize } from "./templates";

const propsConfig = (key) => ({
    inPortal: true,
    inputProps: {
        name: key,
        type: "datetime",
    },
    libOptions: {
        placeholderText: key === "from" ? "Дата начала" : "Дата окончания",
        isClearable: true,
    },
    wrapper: "b-filter__body-cell",
});

const RequestStatistics = (props) => {
    const [data, setData] = useState();
    const [filters, setFilters] = useState({ from: null, to: null });
    const [loading, setLoading] = useState(true);
    const refreshData = () => {
        setLoading(true);
        const reqParams = {};
        if (filters.from) {
            reqParams.from = filters.from;
        }
        if (filters.to) {
            reqParams.to = filters.to;
        }
        requestStatistics(reqParams).then((data) => {
            setData(data);
            setLoading(false);
        });
    };
    useEffect(() => {
        refreshData();
    }, []);

    return (
        <div className="page-content">
            <Transition dir="full">
                <div className="page-book__list book-list list book-list--nofilter">
                    <div className="book-list__head-wrap">
                        <div className="book-list__head">
                            <div
                                className="book-list__head-close close close--sm"
                                onClick={() => props.history.push(paths.root)}
                            />
                            <div className="book-list__head-title">Статистика внешних запросов</div>
                        </div>
                    </div>
                    <div className="container-fluid my-2 d-flex align-items-start">
                        <div className="d-inline-block">
                            <Datetime
                                {...propsConfig("from")}
                                onChange={({ name, value }) => setFilters({ ...filters, [name]: value })}
                                value={filters.from}
                            />
                        </div>
                        <div className="d-inline-block px-3">&mdash;</div>
                        <div className="d-inline-block">
                            <Datetime
                                {...propsConfig("to")}
                                onChange={({ name, value }) => setFilters({ ...filters, [name]: value })}
                                value={filters.to}
                            />
                        </div>
                        <div className="d-inline-block ml-2">
                            <div className="btn btn-sm btn-brand" onClick={refreshData}>
                                Обновить
                            </div>
                        </div>
                    </div>
                    <div className="list__body-wrap">
                        <div className={cn("list__body d-flex flex-column", { loading })}>
                            <Scrollbars>
                                {data && (
                                    <div className="container-fluid pb-3">
                                        <RequestsCount requestsCount={data.requestsCount} />
                                        <RequestsRate requestsRate={data.requestsRate} />
                                        <RequestsDuration requestsDuration={data.requestsDuration} />
                                        <RequestsSize requestsSize={data.requestsSize} />
                                    </div>
                                )}
                            </Scrollbars>
                        </div>
                    </div>
                </div>
            </Transition>
        </div>
    );
};

export default RequestStatistics;
